<template>
  <v-col>
    <!-- Payments data table -->
    <payments-table
      :key="index"
      no-search
      url-api="/payment"
      :headers="headers"
    >
      <!-- Order transaction key-->
      <template v-slot:reference="{ item }">
        <div class="white pa-1">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-img
                v-bind="attrs"
                :src="item.order.barcode"
                lazy-src="/storage/default_img/no_image.png"
                aspect-ratio="1"
                max-width="100"
                max-height="15"
                v-on="on"
              />
            </template>
            <span>TRX #{{ item.order.key }}</span>
          </v-tooltip>
        </div>
      </template>
      <!-- end -->

      <!-- Payment Type -->
      <template v-slot:type="{ item }">
        <div :class="item.type ? 'success--text' : 'red--text'">
          {{ item.type ? "Credit" : "Debit" }}
        </div>
      </template>
      <!-- end -->

      <!--Payment method  -->
      <template v-slot:method="{ item }">
        <div :class="item.method ? 'info--text' : 'warning--text'">
          <template v-if="item.method">
            Live
          </template>
          <template v-else>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                Due
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>Due Date : {{ item.order.dueDate }}</span>
            </v-tooltip>
          </template>
        </div>
      </template>
      <!-- end -->

      <!-- Payment Amount -->
      <template v-slot:amount="{ item }">
        {{ item.order.totalAmount | currency }}
      </template>
      <!-- end -->

      <!-- Payment note -->
      <template v-slot:note="{ item }">
        {{ item.note | truncate(20) | capitalize }}
      </template>
      <!-- end -->

      <!-- Payment Status -->
      <template v-slot:status="{ item }">
        <template v-if="item.status">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="success--text"
                v-bind="attrs"
                v-on="on"
              >
                mdi-check-circle
              </v-icon>
            </template>
            <span>Paid At : {{ item.updated_at }}</span>
          </v-tooltip>
        </template>
        <template v-else>
          <v-icon
            class="red--text"
            small
          >
            mdi-timer-sand
          </v-icon>
        </template>
      </template>
      <!-- End -->

      <!-- ColumnActions -->
      <template v-slot:columnaction="{ item }">
        <!-- Payment details -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              @click.prevent="
                $router.push({
                  name: 'PaymentDetails',
                  params: { id: item.id },
                })
              "
            >
              <v-icon>
                mdi-cash
              </v-icon>
            </v-btn>
          </template>
          <span>More details</span>
        </v-tooltip>
        <!-- end -->
      </template>
      <!-- end columnActions -->
    </payments-table>

    <!-- end data table -->
  </v-col>
</template>

<script>
import PaymentsTable from "../common/DataTable.vue";
export default {
  components: {
    "payments-table": PaymentsTable,
  },
  data() {
    return {
      index: 1,
      headers: [
        {
          text: "Created At",
          align: "start",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Reference",
          sortable: true,
          value: "reference",
          slot: "reference",
          searchables: true,
        },
        {
          text: "Gateway",
          sortable: true,
          value: "gateway",
        },
        {
          text: "Type",
          sortable: true,
          slot: "type",
          value: "type",
        },
        {
          text: "Method",
          sortable: true,
          slot: "method",
          value: "method",
        },
        {
          text: "Amount",
          sortable: true,
          value: "amount",
          slot: "amount",
        },
        {
          text: "Note",
          sortable: false,
          value: "note",
          slot: "note",
        },
        {
          text: "Status",
          sortable: true,
          value: "status",
          slot: "status",
        },

        {
          text: "Actions",
          sortable: false,
          slot: "columnaction",
        },
      ],
    };
  },
};
</script>
